import React from 'react';
import ContractTypes from './components/ContractTypes';
import Cookies from '../../common/components/Cookies';
import SessionExpiredModal from '../../common/components/SessionExpiredModal';
import AppBanner from '../../common/components/AppBanner';

// Styles
import '../../common/scss/init.scss';

const ContractTypesContainer = () => (
  <div>
    <ContractTypes />
    <SessionExpiredModal />
    <Cookies />
    <AppBanner />
  </div>
);

export default ContractTypesContainer;
